import { Button, Radio, Spin, Tag } from 'antd';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import PowerzapNotice from '../PowerzapNotice';
import ChannelMembers from './ChannelMembers';

export default function ChannelScreen({
	channels,
	loadingChannels,
	channelsError,
	channel,
	onSelectChannel,
	onReloadChannels,
	onConfigureChannels,
}) {
	const count = channels.length;
	const active = channels.filter((ch) => ch.ACTIVE !== 'N');
	const empty = !loadingChannels && !channelsError && count === 0;

	// Um canal so: ja vem selecionado, como no Figma (canal-aberto-v3-view-2).
	useEffect(() => {
		if (active.length === 1 && String(channel) !== String(active[0].ID)) {
			onSelectChannel(active[0].ID);
		}
	}, [active.length, active[0]?.ID]);

	const reload = (
		<Button type="link" className="channel-list-action" onClick={onReloadChannels}>
			<FormattedMessage id="channel_reload" />
		</Button>
	);

	return (
		<div className="channel-screen">
			<header className="onboarding-screen-header onboarding-screen-header-left">
				<h1>
					<FormattedMessage id="channel_title" />
				</h1>
				<p>
					<FormattedMessage id="channel_subtitle" />
				</p>
			</header>
			<Spin spinning={loadingChannels}>
				<div className="channel-list">
					{empty ? (
						<div className="channel-list-empty" role="status">
							<p>
								<FormattedMessage id="channel_empty" />
							</p>
							<Button type="link" className="channel-list-action" onClick={onConfigureChannels}>
								<FormattedMessage id="channel_create" />
							</Button>
							{reload}
						</div>
					) : (
						<Radio.Group
							value={channel}
							onChange={(e) => onSelectChannel(e.target.value)}
							className="channel-list-items"
						>
							{channels.map((ch) => {
								const inactive = ch.ACTIVE === 'N';
								return (
									<Radio
										key={ch.ID}
										value={ch.ID}
										disabled={inactive}
										className="channel-list-item"
									>
										<span className="channel-list-name">{ch.LINE_NAME}</span>
										{inactive ? (
											<Tag color="#f50">
												<FormattedMessage id="inactive" />
											</Tag>
										) : null}
										<ChannelMembers channel={ch} />
									</Radio>
								);
							})}
						</Radio.Group>
					)}
					{channelsError || empty ? null : (
						<div className="channel-list-count">
							<FormattedMessage
								id="channel_count"
								values={{ count, padded: String(count).padStart(2, '0') }}
							/>
						</div>
					)}
				</div>
			</Spin>
			{channelsError ? (
				<p className="channel-list-error" role="alert">
					<FormattedMessage id="channel_load_error" /> {reload}
				</p>
			) : null}
			<PowerzapNotice />
		</div>
	);
}
